import { render, staticRenderFns } from "./PolicyText.vue?vue&type=template&id=1ea166d2&"
import script from "./PolicyText.vue?vue&type=script&lang=js&"
export * from "./PolicyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports